import { render, staticRenderFns } from "./CnyPoster.vue?vue&type=template&id=70d14bb9&"
import script from "./CnyPoster.vue?vue&type=script&lang=ts&"
export * from "./CnyPoster.vue?vue&type=script&lang=ts&"
import style0 from "./CnyPoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports